import React from 'react';
import MarketingPage from './MarketingPage';
import marketingPagesData from './marketingPagesData'

const MarketingPageWrapper = (props) => {
    const pageId = props?.match?.params?.id || '01';
    const pageData = marketingPagesData.find(p => p.id === pageId) || marketingPagesData[0];
    return <MarketingPage {...pageData} />;
};

export default MarketingPageWrapper;
